import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import TeacherIcon from "./../../assets/images/teacher.png";
import SchoolIcon from "./../../assets/images/school.png";
import { createLineRenderer } from "utils/lineRenderer";

const MapPage = () => {
  const location = useLocation();
  let row = location.state?.row;

  if (!row) {
    const saved = localStorage.getItem("mapData");
    if (saved) row = JSON.parse(saved);
  }

  useEffect(() => {
    if (!row) return;

    const map = L.map("map", { preferCanvas: true });
    const { drawLine } = createLineRenderer(map);
    const bounds = L.latLngBounds([]);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
    }).addTo(map);

    const pointageIcon = L.icon({
      iconUrl: TeacherIcon,
      iconSize: [40, 55],
      iconAnchor: [20, 55],
      popupAnchor: [0, -48],
    });

    const etablissementIcon = L.icon({
      iconUrl: SchoolIcon,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -36],
    });

    const attLat = parseFloat(row.attLatitude);
    const attLng = parseFloat(row.attLongitude);
    const estLat = parseFloat(row.estLatitude);
    const estLng = parseFloat(row.estLongitude);

    if (row.attLatitude && row.attLongitude) {
      L.marker([row.attLatitude, row.attLongitude], { icon: pointageIcon })
        .addTo(map)
        .bindPopup(`<b>${row.name} ${row.preName}</b><br>Status: ${row.status}`);
      bounds.extend([row.attLatitude, row.attLongitude]);
    }

    if (row.estLatitude && row.estLongitude) {
      L.marker([row.estLatitude, row.estLongitude], { icon: etablissementIcon })
        .addTo(map)
        .bindPopup(`<b>${row.estName}</b><br>Type: ${row.estType}`);
      bounds.extend([row.estLatitude, row.estLongitude]);
    }

    if (attLat && attLng && estLat && estLng) {
      drawLine([attLat, attLng], [estLat, estLng], "#e53935");
    }

    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [50, 50] });
    }

    return () => map.remove();
  }, [row]);

  return <div id="map" style={{ height: "100vh", width: "100%" }}></div>;
};

export default MapPage;
